/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const REMOVE_CURRENT_USER = "REMOVE_CURRENT_USER";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const GOOGLE_LOGIN_REQUEST = "GOOGLE_LOGIN_REQUEST";
export const GOOGLE_LOADER_START = "GOOGLE_LOADER_START";
export const GOOGLE_LOADER_END = "GOOGLE_LOADER_END";

export const ACTIVATE_USER = "ACTIVATE_USER";
export const ACTIVATE_USER_SUCCESS = "ACTIVATION_SUCCESS";
export const ACTIVATE_USER_FAILURE = "ACTIVATION_FAILURE";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const GET_USER_DETAIL = "GET_USER_DETAIL";
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_FAILURE = "GET_USER_DETAIL_FAILURE";

export const SET_CURRENT_USER_DETAIL = "SET_CURRENT_USER_DETAIL";

export const UPDATE_USER_DETAIL = "UPDATE_USER_DETAIL";
export const UPDATE_USER_DETAIL_SUCCESS = "UPDATE_USER_DETAIL_SUCCESS";
export const UPDATE_USER_DETAIL_FAILURE = "UPDATE_USER_DETAIL_FAILURE";

export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";
export const UPDATE_USER_PASSWORD_SUCCESS = "UPDATE_USER_PASSWORD_SUCCESS";
export const UPDATE_USER_PASSWORD_FAILURE = "UPDATE_USER_PASSWORD_FAILURE";

export const SAVE_INVESTOR_PROFILE = "SAVE_INVESTOR_PROFILE";
export const SAVE_INVESTOR_PROFILE_SUCCESS = "SAVE_INVESTOR_PROFILE_SUCCESS";
export const SAVE_INVESTOR_PROFILE_FAILURE = "SAVE_INVESTOR_PROFILE_FAILURE";

export const UPDATE_INVESTOR_PROFILE = "UPDATE_INVESTOR_PROFILE";
export const UPDATE_INVESTOR_PROFILE_SUCCESS =
  "UPDATE_INVESTOR_PROFILE_SUCCESS";
export const UPDATE_INVESTOR_PROFILE_FAILURE =
  "UPDATE_INVESTOR_PROFILE_FAILURE";

export const SAVE_FILTER = "SAVE_FILTER";
export const SAVE_FILTER_SUCCESS = "SAVE_FILTER_SUCCESS";
export const SAVE_FILTER_FAILURE = "SAVE_FILTER_FAILURE";

export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER";
export const GET_CURRENT_FILTER = "GET_CURRENT_FILTER";
